import { BarChart3, Building2, Database, Puzzle, Receipt } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { PageHeader } from "@/components/page-header";
import { MenuCard } from "@/components/ui/menu-card";
import { Skeleton } from "@/components/ui/skeleton";
import { useAdminAccess } from "@/lib/hooks/use-admin";
import { useMe } from "@/lib/hooks/use-clients";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./page.i18n";

export default function AdminPage() {
  const navigate = useNavigate();
  const { me, isLoading: meLoading } = useMe();
  const { isLoading: accessLoading, isQuantfolio, canViewAdmin: canView } = useAdminAccess();
  const t = useT(T);

  const isLoading = meLoading || accessLoading;

  useEffect(() => {
    if (isLoading) return;
    if (!me) {
      navigate("/login", { replace: true });
      return;
    }
    if (!canView) {
      navigate("/", { replace: true });
    }
  }, [isLoading, me, canView, navigate]);

  if (isLoading || !me || !canView) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-10 w-64" />
        <div className="grid gap-6 md:grid-cols-2">
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageHeader title={t.admin} description={t.platformAdministration} />

      <div className="grid gap-6 md:grid-cols-2">
        <MenuCard
          href={isQuantfolio ? "/tenants" : "/admin/tenants"}
          title={t.tenants}
          description={t.tenantsDescription}
          icon={Building2}
        />
        <MenuCard
          href="/admin/tenants-overview"
          title={t.tenantsOverview}
          description={t.tenantsOverviewDescription}
          icon={BarChart3}
        />
        <MenuCard
          href="/admin/usage"
          title={t.usage}
          description={t.usageDescription}
          icon={Receipt}
        />
        <MenuCard
          href="/admin/component-usage"
          title={t.componentUsage}
          description={t.componentUsageDescription}
          icon={Puzzle}
        />
        {isQuantfolio && (
          <MenuCard
            href="/admin/timeseries-instruments"
            title={t.timeseriesInstruments}
            description={t.timeseriesInstrumentsDescription}
            icon={Database}
          />
        )}
      </div>
    </div>
  );
}
